module.exports = __webpack_public_path__ + "static/header-background-fcdaab7f97dfa5430323acc02e6aa6f4.png";